import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EnvironmentService } from '../../core/environment/environment.service';
import { ErrorMessageResponse } from '../model/error-message-response.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  serviceUrl: string = './assets/message/errorMessage.json';
 
  constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

  getErrorMessage(): Observable<any> {
    return (this.http.get<ErrorMessageResponse>(this.serviceUrl));
  }

  getUrlInitialPage(): string {
    return this.environmentService.envModel.initialPage;
  }

}
